export type IPromotion = {
    "id": string,
    "promo_code": string,
    "description": string,
    "discount": number,    
    "start_date": number,
    "end_date": number
}

export type IPromotionRequestPayload = Omit<IPromotion, 'id'>;

export enum PROMOTION_ACTION_TYPE {    
    SELECT_PROMOTION = 'promotion/promotion-select',
    RESET_PROMOTION = 'promotion/reset-promotion',
    PROMOTION_LIST_UPDATE = 'promotion/promotion-list-update',
    PROMOTION_LIST_RESET = 'promotion/promotion-list-reset'
};

export type IPromotionState = {
    selected: IPromotion | undefined,
    list: IPromotion[],
    promo_code: string,    
};

function getInitialPromotionState(): IPromotionState {
    return {
        selected: undefined,
        list: [],
        promo_code: ''
    };
}

export function promotionReducer (state = getInitialPromotionState(), action: {type: PROMOTION_ACTION_TYPE, payload: any}) {
    switch (action.type) {
        case PROMOTION_ACTION_TYPE.SELECT_PROMOTION:
            return {...state, selected: action.payload};
        case PROMOTION_ACTION_TYPE.RESET_PROMOTION:
                return {...state, selected: undefined};
        case PROMOTION_ACTION_TYPE.PROMOTION_LIST_UPDATE:
            return {...state, list: action.payload};
        case PROMOTION_ACTION_TYPE.PROMOTION_LIST_RESET:
                return {...state, list: []};
        default:
            return state;
    }
}